import React from "react";
import { useAuthenticator } from "@aws-amplify/ui-react";
import { DataGrid } from "@mui/x-data-grid";
import { View, useTheme, Heading, Text } from "@aws-amplify/ui-react";
import Box from "@mui/material/Box";

export function Profile() {
  const { user } = useAuthenticator((context) => [context.user]);
  const { tokens } = useTheme();

  // Get user type
  const userType = user.attributes["custom:user_type"];

  // Define fields for producer and distributor
  const fields = userType === "producer"
    ? [
        { id: 1, name: user.attributes["custom:p_company_country"], title: "Regione dell'Azienda" },
        { id: 2, name: user.attributes["custom:p_corporate_name"], title: "Ragione Sociale" },
        { id: 3, name: user.attributes["custom:p_website"], title: "Sito Web" },
      ]
    : [
        { id: 1, name: user.attributes["custom:d_code"], title: "Distributor Code" },
        { id: 2, name: user.attributes["custom:d_contact_name"], title: "Contact Name" },
        { id: 3, name: user.attributes["custom:d_contact_phone"], title: "Contact Phone" },
      ];

  // Define the DataGrid columns
  const columns = [
    {
      field: "name",
      width: 300,
      renderCell: (params) => (
        <div style={{ marginBottom: "1em" }}>
          <Text
            style={{
              fontSize: "1em",
              fontWeight: "bold",
              marginBottom: "0.2em",
              color: tokens.colors.font.primary,
            }}
          >
            {params.value.title}
          </Text>
          <Text style={{ fontSize: "0.95em", color: tokens.colors.font.secondary }}>
            {params.value.name}
          </Text>
        </div>
      ),
    },
  ];

  return (
    <div
      style={{
        fontFamily: "Poppins, Arial, sans-serif",
        backgroundColor: "transparent", // Transparent background
        minHeight: "100vh", // Full viewport height
        display: "flex",
        justifyContent: "center", // Center horizontally
        alignItems: "center", // Center vertically
        padding: "2em", // Add padding for spacing
      }}
    >
      <View
        style={{
          backgroundColor: "white",
          maxWidth: "800px",
          width: "100%",
          borderRadius: "16px",
          padding: "2em",
          textAlign: "left", // Ensure left alignment
        }}
      >
        {/* Header Section */}
        <Heading
          level={2}
          style={{
            fontSize: "2rem",
            fontWeight: "bold",
            color: tokens.colors.font.primary,
            marginBottom: "1em",
          }}
        >
          Merum Account
        </Heading>
        {/* <Text
          style={{
            fontSize: "1.2rem",
            color: tokens.colors.font.secondary,
            marginBottom: "2em",
          }}
        >
        </Text> */}

        {/* DataGrid Section */}
        <Box
          sx={{
            "& .MuiDataGrid-root": {
              backgroundColor: "transparent", // Transparent grid
              border: "none", // Remove all borders
            },
            "& .MuiDataGrid-cell": {
              borderBottom: "none", // Remove cell bottom border
              padding: "0.8em 0",
            },
            "& .MuiDataGrid-columnHeaders": {
              display: "none", // Hide column headers
            },
          }}
        >
          <DataGrid
            getRowHeight={() => "auto"}
            slots={{
              columnHeaders: () => null, // Remove column headers
            }}
            rows={fields.map((field) => ({
              id: field.id,
              name: { name: field.name, title: field.title },
            }))}
            columns={columns}
            hideFooter={true}
            sx={{
              boxShadow: 0,
              border: 0,
              "& .MuiDataGrid-cell:hover": {
                backgroundColor: "transparent", // No hover effect
              },
            }}
          />
        </Box>
      </View>
    </div>
  );
}
